import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BasePipe } from 'app/generated/generated-common';
export enum CargoType {
	None = 0,
	General = 1,
	Hazardous = 2,
	All = 3,
}

@Pipe({
name: 'cargoType'
})
export class CargoTypePipe extends BasePipe<CargoType> implements PipeTransform {
	static prefix = 'Backend.Types.CargoType.';
	static keys = [
		CargoType.None,
		CargoType.General,
		CargoType.Hazardous,
		CargoType.All];
	constructor(
		protected translateService: TranslateService
	) {
		super(translateService);
	}
	toString(value: CargoType): string {
		if (value == null) {
			return null;
		}
		switch (value) {
			case CargoType.None: return 'None';
			case CargoType.General: return 'General';
			case CargoType.Hazardous: return 'Hazardous';
			case CargoType.All: return 'All';
			default: return null;
		}
	}
	transform(value: CargoType, suffix: string, interpolateParams?: Object) {
		const str = this.toString(value);
		if (str) {
			return this.translateOne(CargoTypePipe.prefix + str, suffix, interpolateParams);
		}
		const keys = this.toKeys(CargoTypePipe.keys, CargoTypePipe.prefix, value, suffix);
		return this.translateArray(keys);
	}
}


@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		CargoTypePipe
	],
	exports: [
		CargoTypePipe
	],
	providers: [
		CargoTypePipe
	]
})
export class CargoTypeModule { }
